import { SocialTaskBonusEnums } from 'config/types/bonus/socialTaskBonus'
import useInPage from 'hooks/useInPage'
import { useRequest } from 'hooks/useRequest'
import { useRouter } from 'next/router'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import BonusService from 'services/BonusService'
import { useAppDispatch } from 'state'
import { HunnyToast } from 'utils/toastify'
import { updateSocialTaskBonuses } from '../actions'
import { useSocialTaskBonuses } from './useSocialTaskBonuses'
import { useUserBonus } from './useUserBonus'

/**
 *
 * @param reloadListBonusInSpecificPages Should reload list bonus when stay in Bonus center page | Predefined pages
 * @returns
 */
export const useReceiveSocialTaskBonuses = (reloadListBonusInSpecificPages?: string[]) => {
  const router = useRouter()
  const { fetchBonuses } = useUserBonus()
  const socialTaskBonuses = useSocialTaskBonuses()
  const dispatch = useAppDispatch()
  const isInSpecificPage = useInPage(reloadListBonusInSpecificPages)
  const { execute } = useRequest()
  const { t } = useTranslation()

  const handleReceiveSocialBonus = useCallback(
    async (taskCode: SocialTaskBonusEnums) => {
      if (reloadListBonusInSpecificPages?.length > 0 || isInSpecificPage) {
        fetchBonuses()
      }

      const response = await execute(BonusService.getUserSocialTaskBonusList())
      const userCompletedTask =
        (response?.data?.some((bonus) => bonus?.code === taskCode && bonus?.isCompleted) &&
          socialTaskBonuses.some((bonus) => bonus.code === taskCode)) ||
        false

      if (userCompletedTask) {
        dispatch(updateSocialTaskBonuses({ bonuses: socialTaskBonuses.filter((bonus) => bonus?.code !== taskCode) }))
        if (taskCode === SocialTaskBonusEnums.ConnectTelegram)
          HunnyToast.success(t('Telegram account connected! Your bonus has been added.'))
        else if (taskCode === SocialTaskBonusEnums.VerifyEmailForWeb3User)
          HunnyToast.success(t('Email verified! Your bonus has been added.'))
      } else if (taskCode === SocialTaskBonusEnums.ConnectTelegram) {
        HunnyToast.success(t('Telegram connection is complete'))
      }
    },
    [router.pathname, socialTaskBonuses, reloadListBonusInSpecificPages, isInSpecificPage],
  )

  return useMemo(
    () => ({
      handleReceiveSocialBonus,
    }),
    [handleReceiveSocialBonus],
  )
}
